import { lazy } from 'react'
import Accordion from './Accordion'
import AccordionItem from './AccordionItem'
import { getComponentName } from 'utils/acousticMappings'
import { getValue, getValues, getSelectionValue } from 'utils/utilityHelper'
import EditorialAcousticData from 'components/kanso/patterns/editorial/EditorialAcousticData'
import ContentCardAcousticData from '../contentCard/ContentCardAcousticData'
import ContentCardTileAcousticData from 'components/kanso/components/contentCardTile/ContentCardTileAcousticData'

// const EditorialAcousticData = lazy(() => import('components/kanso/patterns/editorial/EditorialAcousticData'))
// const ContentCardAcousticData = lazy(() => import('components/kanso/components/contentCard/ContentCardAcousticData'))
// const ContentCardTileAcousticData = lazy(() => import('components/kanso/components/contentCardTile/ContentCardTileAcousticData'))

const AccordionAcousticData = (props) => {
  const { 
    accordionContentItems 
  } = props.data
  
  return (
    <Accordion>
      {accordionContentItems?.values?.map((accordionItem, index) => {
        return (
          <AccordionItem title={getValue(accordionItem?.elements?.title)} key={index} icon={getSelectionValue(accordionItem?.elements?.icon)}>   
            {
              getValues(accordionItem?.elements?.contentItems).map((content, index) => {
                if(getComponentName(content.type) === 'Editorial') {
                  return <EditorialAcousticData key={`${content.type}${index}`} data={content?.elements} />
                }
                if(getComponentName(content.type) === 'ContentCard') {
                  return <ContentCardAcousticData key={`${content.type}${index}`} data={content?.elements} />
                }
                if(getComponentName(content.type) === 'ContentCardTile') {
                  return <ContentCardTileAcousticData key={`${content.type}${index}`} data={content?.elements} />
                }
              })
            }
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default AccordionAcousticData
